import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Search } from '@local/client-contracts';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'stack-viewer',
  templateUrl: './stack-viewer.component.html',
  styleUrls: ['./stack-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StackViewerComponent {
  @Input() stack: Search.ErrorItem['stack'];
  showStack$ = new BehaviorSubject(false);
  @Input() set expanded(value: boolean) {
    if (value === this.expanded) return;
    this.showStack$.next(value);
  }

  get expanded(): boolean {
    return this.showStack$.getValue();
  }
}
